module.exports = __webpack_public_path__ + "static/media/warning_cluster.7d1f17cf.svg";